<mat-card appearance="outlined">
  <mat-card-header class="justify-content-between align-items-center mb-3">
    <mat-card-title class="fs-5 mb-0">
      Latest support request
    </mat-card-title>
    <button mat-button color="primary" [routerLink]="['/support','support-requests']" [skipLocationChange]="true">See more</button>
  </mat-card-header>
  <div class="rounded-3 bg-light">
    <sm-data-table [columnHeaders]="tableDisplayColumns" [dataSource]="messageList"
      [showMenuButton]="true" [menuDropdownTemplate]="menuTemplate">
    </sm-data-table>
  </div>
</mat-card>

<ng-template #menuTemplate let-rowvalue>
  <button mat-menu-item>
    <mat-icon class="material-icons-outlined">reply</mat-icon>
    <span>Reply</span>
  </button>
  <button mat-menu-item (click)="markReplied(rowvalue.hashId)" *ngIf="rowvalue.messageStatus != 2">
    <mat-icon class="material-icons-outlined">mark_email_read</mat-icon>
    <span>Mark replied</span>
  </button>
  <button mat-menu-item (click)="markResolved(rowvalue.hashId)" *ngIf="rowvalue.messageStatus != 3">
    <mat-icon class="material-icons-outlined">assignment_turned_in</mat-icon>
    <span>Mark resolved</span>
  </button>
  <button mat-menu-item (click)="markOpened(rowvalue.hashId)" *ngIf="rowvalue.messageStatus != 4">
    <mat-icon class="material-icons-outlined">bookmark_added</mat-icon>
    <span>Mark opened</span>
  </button>
</ng-template>
